export default "__VITE_ASSET__UAuTAPL3__"